import { createSlice } from '@reduxjs/toolkit';
import { ToastSeverity } from '@editor2/types/toastSeverity';

export interface ToastState {
	message: string;
	severity: ToastSeverity;
}

const toastSlice = createSlice({
	name: 'toast',
	initialState: {
		message: null,
		severity: null
	},
	reducers: {
		showToast: (state, action) => {
			const { message, severity = ToastSeverity.Info } = action.payload;
			state.message = message;
			state.severity = severity;
		}
	}
});

export const { showToast } = toastSlice.actions;

export default toastSlice.reducer;
